document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('#main-block .filters-container');
    if (!container) return;

    const prevBtn = container.querySelector('.filters-nav-prev');
    const nextBtn = container.querySelector('.filters-nav-next');
    if (!prevBtn || !nextBtn) return;

    function navigate(direction) {
        const items = Array.from(container.querySelectorAll('.item'));
        if (!items.length) return;

        let currentIndex = items.findIndex(item => item.classList.contains('active'));
        if (currentIndex === -1) currentIndex = 0;

        const nextIndex = (currentIndex + direction + items.length) % items.length;
        items[nextIndex].click();
    }

    prevBtn.addEventListener('click', () => navigate(-1));
    nextBtn.addEventListener('click', () => navigate(1));
});
